(ns ycweb.app.dashboard.planning.planners
  (:require
   [clojure.string :as str]
   [rum.core :as rum]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.app.dashboard.planning.common :as planning.cmn]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(def datatable-key :stockorder.planning.planners/list)

(def editor-key :stockorder.planning.planners/editor)

(defn matches-all-terms?
  "Every whitespace-separated term has to appear somewhere in the text, in any
   order, so \"pots cook\" still finds \"Cookware > Pots\". Plain substring matching
   can't, because the option text puts the parent first."
  [text search]
  (let [haystack (str/lower-case (str text))]
    (every?
      #(str/includes? haystack %)
      (remove str/blank? (str/split (str/lower-case (str search)) #"\s+")))))

(def datatable-fns
  {:editor
   {:form
    {:fields
     {:planner-category/category
      {:search-fn #(matches-all-terms? (:ent/display-name %1) %2)}
      :planner-category/planner
      {:search-fn #(matches-all-terms? (:ent/display-name %1) %2)}}}}})

(def datatable-config
  {:table-name datatable-key
   :row-id :id
   :data-source {:end-point :stockorder.planning.planners/list}
   :select? true
   :options
   {:order :asc
    :sort-title "Planner"
    :sticky-header? true
    :paging? false}
   :buttons
   [{:text "Assign Category"
     :editor editor-key
     :extends :create}
    {:text "Remove Assignment"
     :editor editor-key
     :extends :remove}]
   :column-defs
   [{:key :id :type :selector}
    {:key :planner :title "Planner"}
    {:key :categoryname :title "Category"}
    {:key :categorypath :title "Full Path"}]})

(def editor-config
  {:editor-name editor-key
   :datatable datatable-key
   :mode :read
   :end-points
   {:create :stockorder.planning.planners/add
    :remove :stockorder.planning.planners/remove}
   :fields
   [{:name :planner-category/planner
     :label "Planner:"
     :type :select-search
     :attr {:placeholder "- Select Planner -"}
     :opts-cfg {:lookup {:value :ent/id :text :ent/display-name}}}
    {:name :planner-category/category
     :label "Category:"
     :type :select-search
     :attr {:placeholder "- Select Category -"}
     :opts-cfg {:lookup {:value :ent/id :text :ent/display-name}}}
    {:name :id
     :type :hidden}]})

(defmethod comms/receive :stockorder.planning.planners/list
  [app-atom {:keys [rows planners categories]}]
  (datatables/post-comms app-atom datatable-key {:rows rows})
  (editor/post-comms app-atom editor-key
    {:options
     {:planner-category/planner planners
      :planner-category/category categories}}))

(defn apply-assignments
  "Replaces the table's rows outright. post-comms merges, which leaves a removed
   assignment on screen, and drops the plan items so the plan overview rebuilds
   its planner matrix against the new links rather than serving a cached one."
  [app-atom rows]
  (swap! (datatables/table-cursor app-atom) assoc-in [datatable-key :data]
    (u/index-by :id rows))
  (swap! (cmn/process-cursor app-atom) dissoc :items))

(defmethod comms/receive :stockorder.planning.planners/add [app-atom e]
  (editor/post-submit app-atom editor-key e)
  (when-not (:error e)
    (apply-assignments app-atom (:rows e))))

(defmethod comms/receive :stockorder.planning.planners/remove [app-atom e]
  (editor/post-submit app-atom editor-key e)
  (when-not (:error e)
    (apply-assignments app-atom (:rows e))))

(rum/defc planners-page < rum/reactive [app-atom]
  [:div
   [:div
    {:class (u/bem :flex-grid-group [:flush :align-left :valign-middle])}
    [:div
     {:class (u/bem :flex-grid-block [:fluid :flush :grow-yes])}
     [:div.flex-grid-content
      (headings/heading "Planner Categories" {:type :h1 :size :large})]]
    [:div
     {:class (u/bem :flex-grid-block [:fluid])}
     [:div.flex-grid-content
      (buttons/button-web "Back to Planning Dashboard"
        (merge
          (urlstate/href-props app-atom "planning-new")
          {:style :secondary
           :size :default}))]]
    [:div
     {:class (u/bem :flex-grid-block [:fluid])}
     [:div.flex-grid-content
      (buttons/button-web "Try new layout"
        (merge
          (w.cmn/try-new-layout-props)
          {:style :light
           :size :default}))]]]
   [:div.form-field
    [:span.form-hint
     "These links decide which planners get a column on a plan's category matrix.
      A category with no planner is flagged there. Plan creation offers every
      category regardless of what is assigned here."]]
   [:div.u-min-height-160
    (datatables/table app-atom datatable-key datatable-fns)
    (toaster/loading-overlay app-atom datatable-key)]])

(defmethod flow/render-screen :admin.planning-new/planners [app-atom _]
  (planning.cmn/with-loading-overlay app-atom
    (cmn/permission-lock app-atom "SiteAdmin"
      (planners-page app-atom))))

(defmethod t/transition-open :admin.planning-new/planners [app-atom _ params]
  (w.cmn/redirect-to-new-layout-if-needed! app-atom "planning" params))

(defmethod t/transition-after-open :admin.planning-new/planners [app-atom _ _]
  (presence/open app-atom {:context/ident :stockorder.planning.planners/dashboard})
  (datatables/reset-data app-atom datatable-config {})
  (editor/initiate app-atom editor-config))
